export type Cannabinoid = PrimaryCannabinoid | SecondaryCannabinoid;

/**
 * Order matters here. It determines what order the cannabinoids are displayed in.
 */
export enum PrimaryCannabinoid {
  THC = 'THC',
  CBD = 'CBD',
  THCAndCBD = 'THCAndCBD',
  // TODO - KFFT - figure out how to surgically remove this from this enum.
  //  TAC is not a primary cannabinoid, but is instead the Total Accumulation of Active Cannabinoids.
  TAC = 'TAC'
}

/**
 * Order matters here. It determines what order the cannabinoids are displayed in.
 */
export enum SecondaryCannabinoid {
  CBDA = 'CBDA',
  CBG = 'CBG',
  CBGA = 'CBGA',
  CBL = 'CBL',
  CBLA = 'CBLA',
  CBN = 'CBN',
  CBNA = 'CBNA',
  CBT = 'CBT',
  CBC = 'CBC',
  CBCA = 'CBCA',
  CBCV = 'CBCV',
  CBDV = 'CBDV',
  THC8 = 'THC8',
  THC9 = 'THC9',
  THCA = 'THCA',
  THCV = 'THCV'
}
